import { render, staticRenderFns } from "./recommendedAdd.vue?vue&type=template&id=61b75eec&scoped=true"
import script from "./recommendedAdd.vue?vue&type=script&lang=js"
export * from "./recommendedAdd.vue?vue&type=script&lang=js"
import style0 from "./recommendedAdd.vue?vue&type=style&index=0&id=61b75eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b75eec",
  null
  
)

export default component.exports